import styled from 'styled-components/native'
import { WarningIcon } from 'native-base'

export const CancelIcon = styled(WarningIcon)`
  color: #CC2F2F;
  width: 16px;
  height: 16px;
`
